module.exports = "/assets/ac70c102ef00a75287b83f82895bc824.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2W.png
// module id = 998
// module chunks = 0